import { Injectable } from '@angular/core';

@Injectable()
export class ColorsService {

    APP_COLORS = {
        'primary': '#5d9cec',
        'success': '#27c24c',
        'info': '#23b7e5',
        'warning': '#ff902b',
        'danger': '#f05050',
        'inverse': '#131e26',
        'green': '#37bc9b',
        'pink': '#f532e5',
        'purple': '#7266ba',
        'dark': '#3a3f51',
        'yellow': '#fad732',
        'gray-darker': '#232735',
        'gray-dark': '#3a3f51',
        'gray': '#dde6e9',
        'gray-light': '#e4eaec',
        'gray-lighter': '#edf1f2',
        'beans': '#800000'
    };

    NICE_COLORS = [
        '#eb028b',
        '#0fb199',
        '#ffd300',
        '#7c5fab',
        '#6497b1',
        '#70c179',
        '#007777',
        '#62696e',
        '#0fb199',
        '#1bb2aa',
        '#02899c',
        '#007777',
        '#ffb6c1',
        '#00ffff',
        '#ffd700',
        '#ffc0cb',
        '#02091d',
        '#368155',
        '#6b76ff',
        '#2f89fc',
        '#b9ceeb',
        '#6497b1',
        '#7c5fab',
        '#7c4540',
        '#ffd300',
        '#b8c9dd',
        '#012614',
        '#0aeff0',
        '#26082f',
        '#d04844',
        '#b26666',
        '#70c179',
        '#800000',
        '#99424f',
        '#d2e9eb',
        '#77ab59',
        '#234d20',
        '#007777',
        '#03396c',
        '#62696e',
        '#3b444b',
    ];

    constructor() { }

    byName(name) {
        // console.log(name +' -> ' + this.APP_COLORS[name])
        return (this.APP_COLORS[name] || '#fff');
    }

    byIdx(idx) {
        return (this.NICE_COLORS[idx] || '#fff');
    }
}
